import LegalLayout from "./LegalLayout";
import { TERMS_VERSION, ORG_INFO } from "./legalMeta";

export default function TermsPage() {
  return (
    <LegalLayout title="Términos y Condiciones de Uso" version={TERMS_VERSION}>
      <h2>1. Identificación del Servicio</h2>
      <p>
        <strong>{ORG_INFO.product}</strong> (en adelante, "la Plataforma") es un
        sistema de gestión de clubes juveniles desarrollado por{" "}
        <strong>{ORG_INFO.developer}</strong> de forma{" "}
        <strong>gratuita y sin ánimo de lucro</strong>, para uso{" "}
        <strong>exclusivo</strong> de la {ORG_INFO.client} y sus clubes
        afiliados (Aventureros, Conquistadores, Guías Mayores y similares).
      </p>
      <p>
        El acceso, registro o uso de la Plataforma implica la aceptación plena,
        expresa y sin reservas de los presentes Términos y Condiciones y de la{" "}
        <a href="/privacy" target="_blank" rel="noopener noreferrer">
          Política de Privacidad y Tratamiento de Datos
        </a>
        . Si no está de acuerdo con alguna disposición, debe abstenerse de usar
        la Plataforma.
      </p>

      <h2>2. Uso Permitido</h2>
      <ul>
        <li>
          La Plataforma se ofrece <strong>"TAL CUAL"</strong> y
          <strong> "SEGÚN DISPONIBILIDAD"</strong>, sin garantía de continuidad
          ininterrumpida ni de ausencia de errores.
        </li>
        <li>
          El usuario se compromete a usar la Plataforma únicamente para los
          fines propios de la administración de clubes, conforme a la moral, las
          buenas costumbres, los principios institucionales de la Iglesia
          Adventista del Séptimo Día y la legislación colombiana vigente.
        </li>
        <li>
          Está prohibido: subir contenido ilegal, ofensivo, discriminatorio o
          que infrinja derechos de terceros; intentar vulnerar la seguridad de
          la Plataforma; suplantar identidades; usar la información para fines
          comerciales, políticos o ajenos al propósito eclesiástico.
        </li>
      </ul>

      <h2>3. Cuenta de Usuario</h2>
      <ul>
        <li>
          El usuario es responsable de la veracidad de los datos que suministra
          y de mantener la confidencialidad de su contraseña.
        </li>
        <li>
          Toda actividad realizada desde una cuenta se presume realizada por su
          titular. El usuario debe notificar de inmediato cualquier uso no
          autorizado al correo{" "}
          <a href={`mailto:${ORG_INFO.contactEmail}`}>
            {ORG_INFO.contactEmail}
          </a>
          .
        </li>
        <li>
          Las cuentas deben ser activadas por un administrador autorizado.{" "}
          {ORG_INFO.developer} y la {ORG_INFO.clientShort} se reservan el
          derecho de suspender o eliminar cuentas que infrinjan estos Términos,
          sin necesidad de notificación previa.
        </li>
      </ul>

      <h2>4. Datos de Menores de Edad</h2>
      <p>
        Dado que la Plataforma gestiona información de menores miembros de
        clubes, los padres, tutores o representantes legales son los
        responsables de autorizar el tratamiento de los datos de los menores,
        conforme al artículo 7 de la Ley 1581 de 2012 y al Decreto 1377 de 2013.
        Al registrar a un menor, el usuario declara contar con dicha
        autorización por escrito.
      </p>

      <h2>5. Propiedad Intelectual</h2>
      <p>
        El código fuente, diseño, marcas, logotipos y demás elementos de la
        Plataforma son propiedad de {ORG_INFO.developer}. Las marcas, emblemas y
        nombres de la Iglesia Adventista del Séptimo Día y de la{" "}
        {ORG_INFO.clientShort} son propiedad de sus respectivos titulares y se
        usan bajo autorización institucional.
      </p>
      <p>
        El contenido subido por los usuarios (fotos, documentos, registros)
        permanece de propiedad de su titular o de la organización que lo aporta,
        otorgando una licencia de uso no exclusiva, gratuita y limitada al
        propósito de operación de la Plataforma.
      </p>

      <h2>6. Limitación de Responsabilidad</h2>
      <p>En la máxima medida permitida por la ley aplicable:</p>
      <ul>
        <li>
          {ORG_INFO.developer} <strong>NO SE HACE RESPONSABLE</strong> por daños
          directos, indirectos, incidentales, especiales, consecuenciales o
          punitivos derivados del uso o de la imposibilidad de uso de la
          Plataforma, incluyendo —pero no limitándose a— pérdidas de datos,
          lucro cesante, interrupción del servicio o fallos técnicos atribuibles
          a terceros (proveedores de hosting, conectividad, navegadores, etc.).
        </li>
        <li>
          {ORG_INFO.developer} no garantiza que la Plataforma esté libre de
          errores, vulnerabilidades o que satisfaga necesidades específicas no
          acordadas.
        </li>
        <li>
          La responsabilidad acumulada de {ORG_INFO.developer} frente a
          cualquier reclamación se limita, en todo caso, a CERO PESOS
          COLOMBIANOS (COP $0), dado el carácter gratuito y sin ánimo de lucro
          del servicio.
        </li>
        <li>
          El usuario exonera y se compromete a indemnizar a {ORG_INFO.developer}{" "}
          y a la {ORG_INFO.clientShort} por cualquier reclamación de terceros
          derivada del uso indebido de la Plataforma por parte del usuario.
        </li>
      </ul>

      <h2>7. Seguridad</h2>
      <p>
        La Plataforma implementa medidas de seguridad razonables conforme a la
        industria: cifrado en tránsito (HTTPS/TLS), cifrado de archivos
        sensibles del lado del cliente (AES-256-GCM), autenticación con
        verificación de correo, control de acceso basado en roles y
        almacenamiento en infraestructura de Google Firebase con certificaciones
        internacionales (ISO 27001, SOC 2/3, GDPR-ready).
      </p>
      <p>
        No obstante, ningún sistema es 100% inviolable. El usuario reconoce y
        acepta los riesgos inherentes al uso de servicios en internet.
      </p>

      <h2>8. Modificaciones</h2>
      <p>
        {ORG_INFO.developer} podrá modificar estos Términos en cualquier
        momento. Los cambios sustanciales serán notificados por correo
        electrónico o a través de la Plataforma. El uso continuado tras la
        notificación constituye aceptación de la nueva versión.
      </p>

      <h2>9. Terminación del Servicio</h2>
      <p>
        Al ser un servicio gratuito sin ánimo de lucro, {ORG_INFO.developer}{" "}
        podrá descontinuar la Plataforma en cualquier momento, dando aviso
        razonable y permitiendo a la {ORG_INFO.clientShort} la exportación de
        sus datos.
      </p>

      <h2>10. Ley Aplicable y Jurisdicción</h2>
      <p>
        Estos Términos se rigen por las leyes de la {ORG_INFO.jurisdiction}.
        Cualquier controversia se someterá a los jueces competentes del
        domicilio del demandado, renunciando a cualquier otro fuero.
      </p>

      <h2>11. Contacto</h2>
      <p>
        Para consultas sobre estos Términos:{" "}
        <a href={`mailto:${ORG_INFO.contactEmail}`}>{ORG_INFO.contactEmail}</a>
      </p>
    </LegalLayout>
  );
}
